// ── SEARCH ──
function openSearch() {
  document.getElementById('searchOverlay').classList.add('open');
  setTimeout(() => document.getElementById('searchInput').focus(), 300);
}
function closeSearch() {
  document.getElementById('searchOverlay').classList.remove('open');
  document.getElementById('searchResults').innerHTML = '';
  document.getElementById('searchInput').value = '';
}
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSearch(); });

var searchTimer;
function liveSearch(q) {
  clearTimeout(searchTimer);
  var results = document.getElementById('searchResults');
  if (!q || q.length < 2) { results.innerHTML = ''; return; }
  searchTimer = setTimeout(function() {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = data.resources && data.resources.results && data.resources.results.products || [];
        if (products.length === 0) { results.innerHTML = '<div class="search-no-results">No products found</div>'; return; }
        results.innerHTML = products.map(function(p) {
          var imgSrc = p.featured_image && (p.featured_image.url || p.featured_image);
          var img = imgSrc ? '<img src="' + imgSrc + '" alt="' + p.title + '">' : '<div class="search-result-placeholder"></div>';
          var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'SEK';
          var price = p.price ? (parseFloat(p.price)).toLocaleString('sv-SE', {style:'currency', currency:currency, maximumFractionDigits:0}) : '';
          return '<a href="' + p.url + '" class="search-result-item">' + img + '<div class="search-result-info"><div class="search-result-name">' + p.title + '</div><div class="search-result-price">' + price + '</div></div></a>';
        }).join('');
      });
  }, 250);
}

// ── NAV SCROLL ──
(function() {
  const nav = document.querySelector('.giogio-nav');
  if (!nav) return;
  const hero = document.querySelector('.hero');
  if (!hero) nav.classList.add('scrolled');
  window.addEventListener('scroll', () => {
    const threshold = hero ? hero.offsetHeight - 80 : 60;
    nav.classList.toggle('scrolled', window.scrollY > threshold);
  });
})();


// ── MEGAMENU ──
(function() {
  var wrap = document.querySelector('.nav-shop-wrap');
  var nav = document.querySelector('.giogio-nav');
  var menu = document.querySelector('.nav-megamenu');
  if (!wrap || !nav || !menu) return;
  var closeTimer;
  function open() { clearTimeout(closeTimer); nav.classList.add('megamenu-open'); }
  function scheduleClose() { closeTimer = setTimeout(function() { nav.classList.remove('megamenu-open'); }, 30); }
  wrap.addEventListener('mouseenter', open);
  wrap.addEventListener('mouseleave', scheduleClose);
  menu.addEventListener('mouseenter', open);
  menu.addEventListener('mouseleave', scheduleClose);
})();

// ── HERO SLIDESHOW ──
(function() {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  if (!slides.length) return;
  let current = 0;
  let timer;
  function goTo(index) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');
    current = index;
    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
    clearInterval(timer);
    timer = setInterval(() => goTo((current + 1) % slides.length), 5000);
  }
  dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
  timer = setInterval(() => goTo((current + 1) % slides.length), 5000);
})();

// ── PRODUCT CAROUSEL ──
function carouselSlide(btn, dir) {
  const carousel = btn.closest('.product-carousel');
  const track = carousel.querySelector('.carousel-track');
  const slides = track.querySelectorAll('.product-img');
  const dots = carousel.querySelectorAll('.carousel-dot');
  let idx = parseInt(track.dataset.idx || 0) + dir;
  if (idx < 0) idx = slides.length - 1;
  if (idx >= slides.length) idx = 0;
  track.dataset.idx = idx;
  track.style.transform = `translateX(-${idx * 100}%)`;
  dots.forEach((d, i) => d.classList.toggle('active', i === idx));
}

// ── SAVE / WISHLIST ──
function toggleSave(btn) {
  const id = btn.dataset.id;
  const saved = JSON.parse(localStorage.getItem('giogio_saved') || '{}');
  if (saved[id]) {
    delete saved[id];
    btn.classList.remove('saved');
  } else {
    saved[id] = {
      id,
      name: btn.dataset.name,
      price: btn.dataset.price,
      image: btn.dataset.image || '',
      url: btn.dataset.url || '/collections/all'
    };
    btn.classList.add('saved');
  }
  localStorage.setItem('giogio_saved', JSON.stringify(saved));
}
document.addEventListener('DOMContentLoaded', () => {
  const saved = JSON.parse(localStorage.getItem('giogio_saved') || '{}');
  document.querySelectorAll('.heart-btn').forEach(btn => {
    if (saved[btn.dataset.id]) btn.classList.add('saved');
  });
});

// ── PAGE CONTENT HEADINGS ──
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.page-content p').forEach(function(p) {
    var meaningful = Array.from(p.childNodes).filter(function(n) {
      return !(n.nodeType === 3 && !n.textContent.trim());
    });
    if (meaningful.length === 1 && (meaningful[0].tagName === 'STRONG' || meaningful[0].tagName === 'B')) {
      p.classList.add('page-heading');
    }
  });
});

// ── INSTAGRAM SCROLL ──
(function() {
  const track = document.getElementById('instaTrack');
  if (!track) return;
  const tileW = 336;
  const halfLen = Math.round(track.querySelectorAll('.insta-tile').length / 2);
  const loopW = tileW * halfLen;
  let pos = 0;
  const speed = 0.4;
  let paused = false;
  let manualTarget = null;
  let resumeTimer;

  const wrap = track.closest('.insta-scroll-wrap');
  if (wrap) {
    // Never pause on hover

    // Drag to scroll (mouse)
    let dragStartX = 0;
    let dragStartPos = 0;
    let isDragging = false;
    let didDrag = false;

    wrap.addEventListener('mousedown', (e) => {
      isDragging = true;
      didDrag = false;
      dragStartX = e.clientX;
      dragStartPos = pos;
      manualTarget = null;
      wrap.classList.add('dragging');
      e.preventDefault();
    });
    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const delta = dragStartX - e.clientX;
      if (Math.abs(delta) > 3) didDrag = true;
      pos = (dragStartPos + delta + loopW) % loopW;
    });
    window.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      wrap.classList.remove('dragging');
      paused = false;
      // Block click on tiles if we actually dragged
      if (didDrag) {
        e.stopPropagation();
        const blocker = (ev) => { ev.preventDefault(); ev.stopPropagation(); };
        wrap.addEventListener('click', blocker, { capture: true, once: true });
      }
    });

    // Drag to scroll (touch)
    let touchStartX = 0;
    let touchStartPos = 0;
    wrap.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartPos = pos;
      manualTarget = null;
    }, { passive: true });
    wrap.addEventListener('touchmove', (e) => {
      const delta = touchStartX - e.touches[0].clientX;
      pos = (touchStartPos + delta + loopW) % loopW;
    }, { passive: true });
  }

  function loop() {
    if (manualTarget !== null) {
      const diff = manualTarget - pos;
      if (Math.abs(diff) < 1) { pos = manualTarget; manualTarget = null; }
      else { pos += diff * 0.12; }
    }
    if (pos >= loopW) pos -= loopW;
    if (pos < 0) pos += loopW;
    track.style.transform = `translateX(${-pos}px)`;
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  window.instaScroll = function(dir) {
    clearTimeout(resumeTimer);
    const snapped = Math.round(pos / tileW) * tileW;
    manualTarget = snapped + dir * tileW;
    if (manualTarget >= loopW) manualTarget -= loopW;
    if (manualTarget < 0) manualTarget += loopW;
    resumeTimer = setTimeout(() => { manualTarget = null; }, 2000);
  };
})();

function toggleCurrency(e) {
  e.stopPropagation();
  document.getElementById("currencyDropdown").classList.toggle("open");
}
document.addEventListener("click", function() {
  var d = document.getElementById("currencyDropdown");
  if (d) d.classList.remove("open");
});

// ── HOVER SLIDESHOW (collection grid + featured products) ──
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collection-products-grid .product-carousel, .products-section .product-carousel').forEach(function(carousel) {
    var imgs = carousel.querySelectorAll('.carousel-track .product-img');
    if (imgs.length <= 1) return;
    carousel.addEventListener('mouseenter', function() {
      imgs[0].style.opacity = '0';
      imgs[1].style.opacity = '1';
    });
    carousel.addEventListener('mouseleave', function() {
      imgs[0].style.opacity = '1';
      imgs[1].style.opacity = '0';
    });
  });
});
